//import { OrderReviewComponent } from "./../../components/order-review/order-review.component";
import { ConfigService } from "./../../services/config.service";
import { DetailedQuotaComponent } from "./../detailed-quota/detailed-quota.component";
import { SlickMarketWatchComponent } from "./../../components/slick-market-watch/slick-market-watch.component";
import { ApiService } from "./../../services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { MarketNewsComponent } from "./../../components/market-news/market-news.component";
import { OrderBookComponent } from "./../../components/order-book/order-book.component";
import { MarketTradesComponent } from "./../../components/market-trades/market-trades.component";
import { MarketDepthComponent } from "./../../components/market-depth/market-depth.component";
import { GridsterService } from "./../../services/gridster.service";
import { MarketDepthBidsComponent } from "./../../components/market-depth-bids/market-depth-bids.component";
import { MarketDepthAsksComponent } from "./../../components/market-depth-asks/market-depth-asks.component";
import { TradesComponent } from "./../../components/trades/trades.component";
import { NewsComponent } from "./../../components/news/news.component";
import { HistoricalComponent, historicalData } from "./../../components/historical/historical.component";
import {
  ChangeDetectorRef,
  OnInit,
  QueryList,
  ViewChildren,
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChild,
  HostListener,
} from "@angular/core";
import { CompanyList } from "src/app/models/company-list";
import {
  GridsterConfig,
  GridsterItem,
} from "angular-gridster2";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AccountService } from "src/app/services/account.service";
import { UserIdleService } from "angular-user-idle";
import { SignalRService } from "src/app/services/signalr.service";
import { ToastrService } from "ngx-toastr";
import 'zone.js/dist/zone';
import {
  IgcContentPane,
  IgcDockManagerComponent,
  IgcDockManagerLayout,
  IgcDockManagerPaneType,
  IgcPaneCloseEventArgs,
  IgcSplitPane,
  IgcSplitPaneOrientation,
  IgcDockManagerPane,
  IgcDockManagerPoint
} from 'docking-egid';
import { defineCustomElements } from 'docking-egid/loader';
import { FlexLayoutService } from "../../services/flex-layout.service";
import { HomeComponentsServices } from "../../services/home-components.service";
import { CustomContentPane } from "./custom-content-pane.interface";
import { CompanyDepth } from "src/app/models/company-depth";
import { CompanyTrades, MarketTrades } from "src/app/models/company-trades";
import { MatButton } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";

import { OrderBuyComponent } from "src/app/components/order-buy/order-buy.component";
defineCustomElements();

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
})
export class TestComponent implements OnInit, AfterViewInit {

  dockManagerService: any;
  dockManager: any;
  previousPaneLength: number;
  slotAssigned: Set<number> = new Set();
  isCompaniesLoading: boolean;
  selectedCompanySymbol: any;
  wasChanged: any;
  isLinked: any;
  options: GridsterConfig;
  dashboard: IgcDockManagerLayout;
  @ViewChildren("MWT") components: QueryList<any>;
  private isDialogOpen = false;  // Flag to track dialog state
  addWidget: any;
  companies: CompanyList[] = [];
  isDarktheme;
  selectedSymbolCode;
  darkTheme;
  records = [];
  toggleBool = false;
  selectedEgx: CompanyList;
  companiesUpdates: any = [];
  selectedCompanyReuters: any;
  selectedCompanyName: any;
  selectedCompanyNameAr: any;
  selectedCompanyNameEn: any;
  dashboardIndex = 0;
  dashboardList: IgcDockManagerLayout[] = [];

  //References to our flexLayout element and the Switch dashboard action button
  @ViewChild('flexlayout', { static: true }) flexlayout!: ElementRef<IgcDockManagerComponent>;
  @ViewChild('actionButton', { static: false }) actionButton!: MatButton;
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'F4') {
      event.preventDefault();  // Prevent default F4 action
      this.customF4Function();
    } else if (event.key === 'F5') {
      event.preventDefault();  // Prevent default F5 action
      this.customF5Function();
    }
    else if (event.key === 'F2') {
      event.preventDefault();  // Prevent default F2 action
      this.customF2Function();
      
    }
  }
  customF2Function() {
    this.addWidgett();
  }
  // Custom function for F4 key press
  customF4Function() {
    if (this.isDialogOpen) {
      return;  // Prevent opening a new dialog if one is already open
    }
    this.orderBuy(this.selectedSymbolCode, 0);  // Example parameters, adjust as needed
  }

  // Custom function for F5 key press
  customF5Function() {
    if (this.isDialogOpen) {
      return;  // Prevent opening a new dialog if one is already open
    }
    this.orderBuy(this.selectedSymbolCode, 1);  // Example parameters, adjust as needed
  }

  // Function for placing an order
  orderBuy(company: any, isSell: number) {
    // Check if a dialog is already open, if so don't proceed
    if (this.isDialogOpen) {
      return;
    }

    // Mark the dialog as open
    this.isDialogOpen = true;

    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: 'order-dialog-container',
      data: { symbol: company, type: isSell },
      direction: this.translate.currentLang === 'ar' ? 'rtl' : 'ltr',
    });

    // Handle dialog close event
    dialogRef.afterClosed().subscribe(result => {
      this.isDialogOpen = false;  // Reset flag when dialog is closed
    });
  }
  addWidgett() {
    let obj = {
      reuters: this.selectedCompanyReuters,
      symbol: this.selectedSymbolCode,
      nameEn: this.selectedCompanyNameEn,
      name: this.selectedCompanyName,
    };    
    this.gridService.addGeneric("trades",false);
    this.components.forEach((element) => {
      if (element.componentRef?.instance?.addWidget) {
        element.componentRef.instance.addWidget("trades", obj, false);
      }
    });
  }


  private floatingPaneParams: { [id: string]: Omit<CustomContentPane, 'type' | 'contentId' | 'header'> } = {};

  constructor(
    public gridService: FlexLayoutService,
    public translate: TranslateService,
    private _service: ApiService,
    private nav: Router,
    public accService: AccountService,
    private apiService: ApiService,
    private configService: ConfigService,
    private userIdle: UserIdleService,
    private dialog : MatDialog ,
    public signalR: SignalRService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private homeComponentService: HomeComponentsServices,
  ) {
    // Initialize SignalR and UserIdle
    this.signalR.connectMarketWatch();
    this.signalR.connectTradesUpdates();
    this.userIdle.setConfigValues({
      idle: this.configService.getIdleTime,
      timeout: 10,
    });

    this.isCompaniesLoading = true;
    this._service.fetchTodayMarketWatch().subscribe((res) => {
      this.isCompaniesLoading = false;
      this.companies = res as any[];
      this.WindowResize();
    });
  }

  //Initialize the firefunction (used to transfer companyData to the other dynamic components when a stock is pressed in the slick market watch component ref. )
  fireFunction(symbol: string, reuter: string, nameEn: string, nameAr: string, wasChanged: boolean) {
    this.selectedCompanySymbol = symbol;
    this.wasChanged = false;
    this.selectedCompanyReuters = reuter;
    this.selectedCompanyName = this.translate.currentLang === 'ar' ? nameAr : nameEn;
    this.selectedCompanyNameAr =  nameAr;
    this.selectedCompanyNameEn =  nameEn;
  }

  //This function is crucial as it provides a necessary update to the docking system (DO NOT REMOVE IT)
  clickButtonTwice() {
    if (this.actionButton) {
      this.actionButton._elementRef.nativeElement.dispatchEvent(new Event('click'));
      this.actionButton._elementRef.nativeElement.dispatchEvent(new Event('click'));
    } else {
    }
  }
  onButtonClick() {
    //Necessay function do not remove!!
  }


  ngOnInit(): void {
    //Set the theme based on the in site settings toggle    
    this.darkTheme = localStorage.getItem("darktheme");
    if (this.darkTheme == "dark") {
      this.isDarktheme = false;
    }
    else {
      this.isDarktheme = true;
    }

    //Get the initial dashboard Layout
    const savedIndex = localStorage.getItem('dashboardindex');
    if (savedIndex !== null) {
      this.dashboardIndex = parseInt(savedIndex, 10);
    } else {
      this.dashboardIndex = 0; // Default to the first layout if none is saved
    }
    this.gridService.checkAndSetDefaultLayout()
    this.loadDashboard();



    // Start watching for user inactivity
    this.userIdle.startWatching();
    this.userIdle.onTimerStart().subscribe((count) => {
      if (!Swal.isVisible()) {
        let timerInterval;
        Swal.fire({
          title: this.translate.instant("auto-close"),
          html: "<strong></strong><br/>",
          timer: this.popupAlertTime * 1000,
          timerProgressBar: true,
          didOpen: () => {
            const content = Swal.getHtmlContainer();
            Swal.showLoading();
            timerInterval = setInterval(() => {
              content.getElementsByTagName("strong").item(0).innerHTML = (
                Swal.getTimerLeft() / 1000
              ).toFixed(0);
            }, 100);
          },
          willClose: () => {
            this.userIdle.resetTimer();
          },
        });
      }
    });

    this.userIdle.onTimeout().subscribe(() => {
      if (sessionStorage.getItem("userName") != null) {
        let userName = sessionStorage.getItem("userName");
        this.apiService.logOut(userName).subscribe(
          (x) => {
            this.accService.logout();
          },
          (err) => { }
        );
        this.userIdle.stopTimer();
        this.userIdle.stopWatching();
      }
    });
    //Subscribe to the paneAdded subject ref. flex-layout.service
    this.gridService.paneAdded$.subscribe(pane => {
      this.addFloatingPane(pane.id, pane.header, pane.headerId, pane.isLinked);
    });
  }

  //Handle refresh action to maintain current dashboard and it's data (by saving the flex layout (to connect to the dynamic components in the HTML)
  //And the addWidget function in afterViewInit will populate the data)
  @HostListener('window:beforeunload', ['$event'])
  saveLayoutBeforeUnload(event: any) {
    if (!this.gridService.isResetting) {
      localStorage.setItem("dashboardLayout", JSON.stringify(this.dashboard));
      localStorage.setItem("dashboardindex", this.dashboardIndex.toString());
      localStorage.setItem('Map', JSON.stringify(this.gridService.contentIdMap));
      this.assignFireFunctionToComponents();


    }
  }

  loadDashboard() {
    // Set default dashboard initially
    this.dashboard = this.gridService.defaultDash;

    try {
      // Fetch dashboard layout data from localStorage
      const dashboardString = localStorage.getItem('dashboardLayoutLists');
      const dashboardIndexString = localStorage.getItem('dashboardindex');
      let dashboardLayoutString = localStorage.getItem('dashboardLayout');

      // Parse fetched data
      this.dashboardList = dashboardString ? JSON.parse(dashboardString) : [];

      // Initialize dashboardLayout if it's the first time and dashboardList exists
      if (!dashboardLayoutString && this.dashboardList.length > 0) {
        // Set the first dashboard in the list as the initial layout
        dashboardLayoutString = JSON.stringify(this.dashboardList[0]);
        localStorage.setItem('dashboardLayout', dashboardLayoutString);
      }

      const dashboardIndex = dashboardIndexString ? parseInt(dashboardIndexString, 10) : null;
      const parsedDashboardLayout = dashboardLayoutString ? JSON.parse(dashboardLayoutString) as IgcDockManagerLayout : null;

      // Check if we have any dashboards in the list
      if (this.dashboardList.length === 0) {
        // No dashboards, fall back to default dashboard
        this.dashboard = this.gridService.defaultDash;
      } else if (dashboardIndex !== null && dashboardIndex >= 0 && dashboardIndex < this.dashboardList.length) {
        // If a valid index is found, load the corresponding dashboard
        this.dashboard = parsedDashboardLayout || this.dashboardList[dashboardIndex];
      } else {
        // Invalid index, fallback to default dashboard
        this.dashboard = this.gridService.defaultDash;
      }
      //     this.cdr.detectChanges();

    } catch (error) {
      // Handle any errors that occur during the loading process
      this.dashboard = this.gridService.defaultDash; // Fallback to default in case of an error
    }

        // Trigger change detection and assign fire functions
        this.cdr.detectChanges();
        this.assignFireFunctionToComponents();
  }
  assignFireFunctionToComponents(): void {
    const storedValue = localStorage.getItem('Map');

    // Check if the stored value is double-encoded and decode if necessary
    if (storedValue) {
      try {
        // Try parsing multiple levels if needed
        this.gridService.contentIdMap = JSON.parse(JSON.parse(storedValue));
      } catch (e) {
        // If it fails, it's probably only encoded once
        this.gridService.contentIdMap = JSON.parse(storedValue);
      }
    } else {
      // If no value in local storage, initialize as an empty object
      this.gridService.contentIdMap = this.gridService.contentIdMap;
    }
    this.cdr.detectChanges(); // Ensure the view is updated
  }



  getAllPanes(rootPane: IgcDockManagerPane): IgcContentPane[] {
    return this.gridService.getAllPanes(rootPane);
  }
  getAllFloatingPanes(floatingPanes: IgcDockManagerPane[]): IgcContentPane[] {
    return this.gridService.getAllFloatingPanes(floatingPanes);
  }
  checkSplitAndTabGroupPanes(): boolean {
    const rootPanes = this.dashboard.rootPane.panes || [];
    const floatingPanes = this.dashboard.floatingPanes.length ? this.dashboard.floatingPanes : [];
    const allPanes = [...rootPanes, ...floatingPanes];
    return this.gridService.checkSplitAndTabGroupPanes(allPanes);
  }

//Initialize pane params
  setPaneParams(id: string, params: Omit<CustomContentPane, 'type' | 'contentId' | 'header'>) {
    this.floatingPaneParams[id] = params;
  }
//Slot is the attribute of the flexLayout pane which connects the pane with it's content, it should be the contentID 
  getSlotForPane(contentId: string): string {
    return this.gridService.getSlotByContentId(contentId);
  }
//Gets whether or not the pane is linked
  getIsLinkedForPane(contentId: string): boolean {
    return this.gridService.getIsLinkedForPane(contentId);
  }

//The Main add a new floating pane functionality
  addFloatingPane(id: string, header: string, headerId: string, isLinked: boolean, additionalParams: Omit<CustomContentPane, 'type' | 'contentId' | 'header'> = {
    symbolCode: "",
    reuters: "",
    isLinked: false,
    companyName: "",
    state: "",
    Id: 0,
    wasChanged: false
  }) {
    const params = this.floatingPaneParams[id] || {
      symbolCode: '',
      reuters: '',
      isLinked: false,
      companyName: '',
      state: '',
      Id: 0,
      wasChanged: false
    };
//Floating panes are content panes in split panes, so we first create the content pane (but our custom one) 
    const newPane: CustomContentPane = {
      type: IgcDockManagerPaneType.contentPane,
      contentId: id,
      header: header,
      headerId: headerId,
      ...params,
      symbolCode: params.symbolCode!,
      reuters: params.reuters!,
      isLinked: isLinked,
      companyName: params.companyName!,
      state: params.state!,
      Id: params.Id!,
      wasChanged: params.wasChanged
    };
//Then we place it in a new split pane
    const newFloatingPane: IgcSplitPane = {
      type: IgcDockManagerPaneType.splitPane,
      orientation: IgcSplitPaneOrientation.horizontal,
      floatingHeight: 500,
      floatingWidth: 550,
      floatingLocation: { x: 200, y: 300 },
      panes: [newPane],
    };
//we make sure the dashboard has floating panes available
    if (!this.dashboard.floatingPanes) {
      this.dashboard.floatingPanes = [];
    }
//We push the new pane in our dashboard
    this.dashboard.floatingPanes.push(newFloatingPane);
//We need to invoke a refresh on the HTML component itself to render the data
    if (this.flexlayout && this.flexlayout.nativeElement) {
      this.flexlayout.nativeElement.layout = this.dashboard;
      this.flexlayout.nativeElement.layout.floatingPanes = this.dashboard.floatingPanes;
//This is the most important line here as it handles the HTML update (NEVER Remove)      
      this.flexlayout.nativeElement.layout = Object.assign({}, this.flexlayout.nativeElement.layout);
//We need to save the new contentId Map to our localStorage to maintain the data of the pane's contents      
      localStorage.setItem('Map', JSON.stringify(this.gridService.contentIdMap));
    }
//Next we need to update our service's dashboard to match our updated dashboard before saving our updated dashboard in our local storage    
    this.gridService.defaultDash = this.dashboard;
    this.gridService.updateLayout(this.dashboard, this.dashboardIndex);  


//Manually detect changes
    this.cdr.detectChanges();
  }


ngAfterViewInit(): void {
//Atter rendering the components we need to assign the firefunctions to all rendered components and then click the button twice to trigger an update
    this.assignFireFunctionToComponents();
    this.clickButtonTwice();
//This listens to the package event on pane close, search for the pane to make sure it's not the last pane, close it if possible then update the layout
    this.flexlayout.nativeElement.addEventListener
      ("paneClose",
        (ev: CustomEvent<IgcPaneCloseEventArgs>) => {
          var dockedPanes = this.getAllPanes(this.flexlayout.nativeElement.layout.rootPane);
          var floatingPanes = this.getAllFloatingPanes(this.flexlayout.nativeElement.layout.floatingPanes);
          const allPanes = floatingPanes.length + dockedPanes.length;
          const lastTabGroupPane = this.checkSplitAndTabGroupPanes();
          if (allPanes <= 1 || lastTabGroupPane) {
            ev.preventDefault(); this.toastr.warning
              (this.translate.instant('Cannot close the last pane'));
          }
          else {
            this.gridService.defaultDash = this.dashboard;
            this.gridService.updateLayout(this.dashboard, this.dashboardIndex);
            this.cdr.detectChanges();
          }
        });
//this listens to any layout change to update the dashboard layout
    this.flexlayout.nativeElement.addEventListener
      ("layoutChange",
        (ev: CustomEvent) => {
          var dockedPanes = this.getAllPanes(this.dashboard.rootPane);
          var floatingPanes = this.getAllFloatingPanes(this.dashboard.floatingPanes);
          const allPanes = floatingPanes.length + dockedPanes.length;
          const lastTabGroupPane = this.checkSplitAndTabGroupPanes();

          this.gridService.defaultDash = this.dashboard;
          this.gridService.updateLayout(this.dashboard, this.dashboardIndex);
          this.cdr.detectChanges();

          localStorage.setItem("dashboardLayout", JSON.stringify(this.dashboard));
        });




//This here is the entire logic of our data update for the dynamic components, the dynamic components are defined in a queryList which is mapped in the HTML
//We subscribe to any changes on these component (the firefunction handles mainly any click on the stocks in the slick-market-watch component or marketWatch
//which sends the compnay's data to all other dynamic components)
//The add widget enables adding unlinked panes (updated only once upon creation and do not respond to the firefunction)
    this.components.changes.subscribe((queryList) => {

      this.components.forEach((element) => {
        //The element found here will be the element which is changed probably the market-watch pane
        element.componentRef.instance.fireFunction = (symbol, reuter, nameEn, nameAr, wasChanged) => {
          this.selectedCompanyReuters = reuter;
          this.selectedCompanyName =  nameAr;
          this.selectedCompanyNameEn =  nameEn;
          this.selectedSymbolCode = symbol;
        //We then parse all the other component and check if they are linked to update them with the new company data (we should not update them if they are unlinked)
          this.components.forEach((otherComponent) => {
            var componentRef = otherComponent.componentRef.instance;
            if (componentRef.isLinked) {

              componentRef.symbolCode = symbol;
              componentRef.reuters = reuter;



              if (this.translate.currentLang === "ar") {
                componentRef.companyName = nameAr;
              } else if (this.translate.currentLang === "en") {
                componentRef.companyName = nameEn;
              }
              //The market watch needs a state update as well
              if (componentRef.name === "market-watch") {
                this.gridService.setPaneCompanyData(componentRef.id, componentRef.symbolCode, componentRef.reuters, componentRef.companyName, componentRef.wasChanged, componentRef.state);
              }
              else {
                this.gridService.setPaneCompanyData(componentRef.id, componentRef.symbolCode, componentRef.reuters, componentRef.companyName, componentRef.wasChanged, null);
              }
              //We then see which component it is so we can update the dynamics component's propeties from within the dynamic element itself (not the ts of the component)
              //ref. each components's ts component and the home-components.service
              switch (componentRef.name) {
                case "market-watch":
                  break;
                case "news":
                  componentRef.isNewsLoading = true;
                  this.homeComponentService.fetchCompanyNews(componentRef.symbolCode)
                    .subscribe((res) => {
                      componentRef.companyNews = res.filter((book) => book.TYPE === 1);
                      componentRef.announcements = res.filter((book) => book.TYPE !== 1);
                      componentRef.isNewsLoading = false;
                    });
                  break;
                case "trades":
                  componentRef.isTradesLoading = true;
                  if (componentRef.isTime)
                    this.homeComponentService.fetchCompanyTradesByTime(componentRef.symbolCode).subscribe((res) => {
                      componentRef.isTradesLoading = false;
                      componentRef.timeTrades = res as MarketTrades[];
                    });
                  else
                    this.homeComponentService.fetchCompanyTradesByPrice(componentRef.symbolCode).subscribe((res) => {
                      componentRef.isTradesLoading = false;
                      componentRef.priceTrades = res as CompanyTrades;
                    });

                  break;
                case "depth-asks":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                case "depth-bids":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                case "market-depth":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                  //Not needed so far
                case "market-trades":
                  // componentRef.isTradesLoading = true;
                  // this.homeComponentService.fetchMarketTrades().subscribe((res) => {
                  //   componentRef.isTradesLoading = false;
                  //   componentRef.companyTrades = res as MarketTrades[];
                  // });
                  // const marketNames = this.homeComponentService.getMarketNames();
                  // if (marketNames) {
                  //   componentRef.allMarketNames = marketNames;
                  // }

                  // // Subscribe to market names changes
                  // this.homeComponentService.subscribeToMarketNames((names) => {
                  //   componentRef.allMarketNames = names;
                  // });

                  // // Subscribe to trade updates
                  // this.homeComponentService.subscribeToTradeUpdates(componentRef.allMarketNames, (trade) => {
                  //   componentRef.companyTrades.unshift(trade);
                  //   if (componentRef.companyTrades.length > 100) {
                  //     componentRef.companyTrades.length = 100;
                  //   }
                  // });
                  break;

                  //Setting an inital date of 1 month or any duration breaks everything , no idea why
                case "historical":
                  const today = new Date();
                  const startDate = new Date();
                  startDate.setMonth(today.getMonth() - 1);
                  componentRef.isDepthLoading = true;
                  // this.homeComponentService.fetchCompanyMarketDepth(componentRef.symbolCode,startDate,today).subscribe((res) => {
                  //   componentRef.data = [];
                  //   componentRef.data = res as historicalData[];
                  //   componentRef.isDepthLoading = false;
                  // });
                  break;
                case "bids":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                case "asks":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                case "order-book":
                  break;
                case "market-news":
                  break;
                case "order-review":
                  break;
                case "detailed-quota":
                  break;
                default:
                  break;
              }


            }
          });
        }
        //Next we update the unlinked elements upon creation, we check if they are unlinked and not changed before updating them once
        element.componentRef.instance.addWidget = (name, companyData, isLinked) => {
          this.components.forEach((otherComponent) => {
            var componentRef = otherComponent.componentRef.instance;
            if (
              !componentRef.isLinked &&
              (componentRef.name === name)
              && componentRef.wasChanged === false
            ) {
              componentRef.wasChanged = true
              componentRef.symbolCode = companyData.symbol;
              componentRef.reuters = companyData.reuters;

              if (this.translate.currentLang === "ar") {
                componentRef.companyName = companyData.name;
              } else if (this.translate.currentLang === "en") {
                componentRef.companyName = companyData.nameEn;
              }
              if (componentRef.name === "market-watch") {
                this.gridService.setPaneCompanyData(componentRef.id, componentRef.symbolCode, componentRef.reuters, componentRef.companyName, componentRef.wasChanged, componentRef.state);
              }
              else {
                this.gridService.setPaneCompanyData(componentRef.id, componentRef.symbolCode, componentRef.reuters, componentRef.companyName, componentRef.wasChanged, null);
              }
              switch (componentRef.name) {
                case "market-watch":
                  break;
                case "news":
                  if (componentRef.name == "news") {
                    componentRef.isNewsLoading = true;
                    this.homeComponentService.fetchCompanyNews(componentRef.symbolCode)
                      .subscribe((res) => {
                        componentRef.companyNews = res.filter((book) => book.TYPE === 1);
                        componentRef.announcements = res.filter((book) => book.TYPE !== 1);
                        componentRef.isNewsLoading = false;
                      });
                  }

                  break;
                case "trades":
                  break;
                case "depth-asks":
                  break;
                case "depth-bids":
                  break;
                case "market-depth":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                //Not needed so far
                case "market-trades":
                  // componentRef.isTradesLoading = true;
                  // this.homeComponentService.fetchMarketTrades().subscribe((res) => {
                  //   componentRef.isTradesLoading = false;
                  //   componentRef.companyTrades = res as MarketTrades[];
                  // });
                  // const marketNames = this.homeComponentService.getMarketNames();
                  // if (marketNames) {
                  //   componentRef.allMarketNames = marketNames;
                  // }

                  // // Subscribe to market names changes
                  // this.homeComponentService.subscribeToMarketNames((names) => {
                  //   componentRef.allMarketNames = names;
                  // });

                  // // Subscribe to trade updates
                  // this.homeComponentService.subscribeToTradeUpdates(componentRef.allMarketNames, (trade) => {
                  //   componentRef.companyTrades.unshift(trade);
                  //   if (componentRef.companyTrades.length > 100) {
                  //     componentRef.companyTrades.length = 100;
                  //   }
                  // });
                  break;

                  //Setting an inital date of 1 month or any duration breaks everything , no idea why
                case "historical":
                  const today = new Date();
                  const startDate = new Date();
                  startDate.setMonth(today.getMonth() - 1);
                  componentRef.isDepthLoading = true;
                  // this.homeComponentService.fetchCompanyMarketDepth(componentRef.symbolCode,startDate,today).subscribe((res) => {
                  //   componentRef.data = [];
                  //   componentRef.data = res as historicalData[];
                  //   componentRef.isDepthLoading = false;
                  // });
                  break;
                case "bids":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                case "asks":
                  if (componentRef.symbolCode) {
                    componentRef.companyDepth = null;
                    componentRef.isDepthLoading = true;
                    if (componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByOrder(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                    else if (!componentRef.isOrder) {
                      this.homeComponentService.fetchDepthByPrice(componentRef.symbolCode).subscribe((res) => {
                        componentRef.isDepthLoading = false;
                        componentRef.companyDepth = res as CompanyDepth;
                      });;
                    }
                  }

                  if (!componentRef.isOrder && componentRef.symbolCode) {
                    if (componentRef.depthConnection) {
                      this.homeComponentService.stopSignalRConnection(componentRef.depthConnection);
                    }


                    this.homeComponentService.connectSignalR(componentRef.symbolCode).then((connection) => {
                      componentRef.depthConnection = connection;
                      connection.on("sendBidsAsksForSymbol", (depthUpdate) => {
                        const update = depthUpdate[0]["MarketDepth"] as CompanyDepth;
                        componentRef.companyDepth.asksPerPrice = update.asksPerPrice;
                        componentRef.companyDepth.bidsPerPrice = update.bidsPerPrice;
                        componentRef.companyDepth.totalsBidsAndAsks = update.totalsBidsAndAsks;
                      });
                    });
                  }
                  break;
                case "order-book":
                  break;
                case "market-news":
                  break;
                case "order-review":
                  break;
                case "detailed-quota":
                  break;
                default:
                  break;
              }

            }

          });
        }



      });

    });
  }

//This handles adding a new dashboard, updating the index and saving the last dashboard to the local storage  
  addNewDashboard() {
    const index = this.gridService.addNewDashboard();

    // Fetch the updated dashboard list from localStorage
    this.dashboardList = this.gridService.getGrid() || [];

    // Ensure dashboardIndex is valid
    this.dashboardIndex = index - 1;
    if (this.dashboardIndex >= 0 && this.dashboardIndex < this.dashboardList.length) {
      this.dashboard = this.dashboardList[this.dashboardIndex];
      this.WindowResize();

      // Save layout and update
      this.gridService.defaultDash = this.dashboard;
      this.gridService.updateLayout(this.dashboard, this.dashboardIndex);
      this.gridService.saveLayoutList(this.dashboardList);
      this.gridService.loadNewLayout(this.dashboardIndex);

    } else {
    }

    localStorage.setItem('dashboardindex', JSON.stringify(this.dashboardIndex));

  }

  //This handles switching dashboards, updating the index and saving the last dashboard to the local storage, loading the other dashboard from the localstorage  
  switchDashboard(index: number) {
    if (index >= 0 && index < this.dashboardList.length) {
      this.dashboardIndex = index;
      this.dashboard = this.dashboardList[this.dashboardIndex];

      // Load the corresponding layout
      const layout = this.gridService.loadLayout();

      if (layout) {
        this.gridService.defaultDash = this.dashboard;
        this.gridService.updateLayout(this.dashboard, this.dashboardIndex); // Automatically update and save the new layout
        this.gridService.saveLayoutList(this.dashboardList);
      } 
    }
    localStorage.setItem('dashboardindex', JSON.stringify(this.dashboardIndex));
 
  }


//This handles removing dashboard, updating the index and removing the dashboard from the local storage 
  removeDashboard(index: number) {
    if (index >= 0 && index < this.dashboardList.length) {
      this.gridService.removeDashboard(index);
      this.dashboardList = this.gridService.getGrid();
      this.dashboardIndex = Math.min(this.dashboardIndex, this.dashboardList.length - 1);
      this.dashboard = this.dashboardList[this.dashboardIndex];

      this.WindowResize();
      this.gridService.defaultDash = this.dashboard;
      this.gridService.updateLayout(this.dashboard, this.dashboardIndex); // Save layout
      this.gridService.saveLayoutList(this.dashboardList);

    } 
     localStorage.setItem('dashboardindex', JSON.stringify(this.dashboardIndex));

  }

  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }

//This allows the dynamic component to find the component it should render based on the pane's headerId 
  public get(name: string): any {
    switch (name) {
      case "market-watch":
        return SlickMarketWatchComponent;
      case "news":
        return NewsComponent;
      case "trades":
        return TradesComponent;
      case "depth-asks":
        return MarketDepthAsksComponent;
      case "depth-bids":
        return MarketDepthBidsComponent;
      case "market-depth":
        return MarketDepthComponent;
      case "market-trades":
        return MarketTradesComponent;
      case "historical":
        return HistoricalComponent;
      case "bids":
        return MarketDepthBidsComponent;
      case "asks":
        return MarketDepthAsksComponent;
      case "order-book":
        return OrderBookComponent;
      case "market-news":
        return MarketNewsComponent;
      // case "order-review":
      //   return OrderReviewComponent;
      case "detailed-quota":
        return DetailedQuotaComponent;
      default:
        return null;
    }
  }

  changedOptions(): void {
    if (this.options.api && this.options.api.optionsChanged) {
      this.options.api.optionsChanged();
    }
  }

  popupAlertTime = 10;

  ngOnDestroy(): void {
    this.signalR.disconnectMwSignalr();
    this.signalR.disconnectTradesSignalr();
  }

  navigateProfile(item) {
    this.nav
      .navigate(["/company-profile", item.SYMBOL_CODE, item.Reuters])
      .then(() => (this.toggleBool = false));
  }
}